import {FC, useLayoutEffect} from "react";
import {gsap} from "gsap";
import TweenTarget = gsap.TweenTarget;
import {coin1, coin2, coin3, coin4, coin5, coin6, coin7, coin8, coin9, coin10} from "../coinsImages";
import "./CoinsRight.scss";


const CoinsRight: FC = () => {
	const coins = [coin6, coin5, coin7, coin8, coin10, coin9, coin5, coin1, coin7, coin2, coin4, coin3, coin1];

	useLayoutEffect(() => {
		let coinsEl: TweenTarget[] = gsap.utils.toArray(".coins-right .coin")
		coinsEl.forEach((coin, index) => {
			gsap.fromTo(coin,{ opacity: 0 },
				{
					clearProps: "all",
					opacity: 1,
					duration: 2,
					delay: 1.5 + (index / 5),
					onComplete: () => {gsap.killTweensOf(coin);}
				}
			)
		})
	}, []);

	return(
		<div className="coins-right">
			<div className="coins-right__wrapper">
				{
					coins.map((coin, index) => (
						<div className={`coin coin-${index + 1}`} key={`coin-${index + 1}`}>
							<img src={coin} alt={`coin-${index + 1}`}/>
						</div>
					))
				}
			</div>
		</div>
	)
}
export default CoinsRight